import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import i18n from "i18next";
import { ITeamDto } from "../../../Models/ITeamDto";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";

interface IDialogDeleteTeam {
  onClose(): void;
  open: boolean;
  selectedTeam?: ITeamDto;
  onUpdate(): void;
}

function DialogDeleteTeam(props: IDialogDeleteTeam) {
  const deleteTeam = (teamGuid: string) => {
    fetchWrapper
      .getWithAuth(baseUrl + "/api/teams/DeleteTeam?id=" + teamGuid)
      .then((result: any) => {
        props.onUpdate();
      });
  };
  return (
    <Dialog open={props.open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {i18n.t<string>("deleteTeam")}
          </DialogTitle>
          <DialogContent>{i18n.t<string>("deleteTeamText")}</DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                if (props.selectedTeam) {
                  deleteTeam(props.selectedTeam?.teamId);
                }
                props.onClose();
              }}
              appearance="primary"
            >
              {i18n.t<string>("delete")}
            </Button>
            <Button
              onClick={() => {
                props.onClose();
              }}
            >
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogDeleteTeam;
